import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';
import { SharedMenu } from 'modules/shared-menu/types';

import { CentralisedAddButton } from '../../SharedMenuPage/components/CentralisedAddButton';

type SingleVenueHeaderProps = {
  selection: SharedMenu;
  onClickCreateCategory: () => void;
  onClickImageGallery: () => void;
};

const Root = styled.div`
  display: flex;
  padding: 24px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  justify-content: space-between;
  align-items: end;
`;

const SelectionHeader = styled(T.Heading4)`
  display: flex;
  flex-direction: column;
`;

const SelectionNameAndStatus = styled.div`
  display: flex;
  align-items: center;
`;

const SelectionActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SingleVenueHeader = ({ onClickCreateCategory, onClickImageGallery }: SingleVenueHeaderProps) => {
  const menuPermissions = useOfferingMenuPermissionsContext();

  return (
    <Root>
      <SelectionHeader>
        <SelectionNameAndStatus>
          <FormattedMessage id="menu.menu-sync.status-header" />
        </SelectionNameAndStatus>
      </SelectionHeader>
      <SelectionActionsContainer>
        {menuPermissions.contentEdit && (
          <CentralisedAddButton
            onClickCreateCategory={onClickCreateCategory}
            onClickImageGallery={onClickImageGallery}
          />
        )}
      </SelectionActionsContainer>
    </Root>
  );
};
